/**
 * The aspect ratio constant which indicates that the width (of whatever the
 * aspect ratio constant is used for) is smaller than the height.
 *
 * @type {Symbol}
 */
export const ASPECT_RATIO_NARROW = Symbol('ASPECT_RATIO_NARROW');

/**
 * The aspect ratio constant which indicates that the width (of whatever the
 * aspect ratio constant is used for) is larger than the height.
 *
 * @type {Symbol}
 */
export const ASPECT_RATIO_WIDE = Symbol('ASPECT_RATIO_WIDE');

/**
 * The vertical padding to be applied to the navigation bar and toolbox.
 *
 * @type {Symbol}
 */
export const PADDING_VERTICAL = 8;

/**
 * Padding to be applied to the conference container.
 */
export const CONFERENCE_PADDING = 4;

/**
 * The gap between conference items (e.g. the gap between the navigation bar and
 * the tiles).
 */
export const CONFERENCE_ITEMS_GAP = 4;
